import { render, staticRenderFns } from "./EducationalGroupStudentCards.vue?vue&type=template&id=d6f948fa&"
import script from "./EducationalGroupStudentCards.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupStudentCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports